import { Button } from "@mui/material";
import Box from "@mui/material/Box";

import { useLeftSidebarNav } from "@/components/NewDesign/useLeftSidebarNav";
import UserFeedbackForm from "@/components/UserFeedbackForm.tsx";
import { useBootIndicatorLook } from "@/hooks/useBootIndicatorLook";
import PortalDialog from "@/ui/PortalDialog.tsx";
import SidebarNav from "@/ui/SidebarNav";
import { zinc } from "@/ui/tokens";

export default function LeftSidebar() {
  const { topLinks, bottomLinks, helpOpen, closeHelp, notificationsDeniedOpen, closeNotificationsDenied } =
    useLeftSidebarNav();
  // `null` rather than `undefined` when nothing shows, so the rail keeps the room for the marks to fade out in.
  const bootLook = useBootIndicatorLook() ?? null;

  return (
    <>
      <SidebarNav topLinks={topLinks} bottomLinks={bottomLinks} bootLook={bootLook} />

      <PortalDialog title="Leave Feedback" open={helpOpen} onClose={closeHelp}>
        <UserFeedbackForm onClose={closeHelp} />
      </PortalDialog>
      <PortalDialog title="Notifications Blocked" open={notificationsDeniedOpen} onClose={closeNotificationsDenied}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box sx={{ color: zinc[300] }}>Browser notifications have been blocked. To re-enable them:</Box>
          <Box
            component="ol"
            sx={{
              py: 0,
              px: 1,
              listStyleType: "decimal",
              listStylePosition: "inside",
              color: zinc[300],
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <li>Click the lock or site-settings icon in your browser's address bar</li>
            <li>
              Find the <strong>Notifications</strong> permission
            </li>
            <li>
              Change it from <strong>Block</strong> to <strong>Allow</strong>
            </li>
            <li>Reload this page</li>
          </Box>
          <Button
            onClick={closeNotificationsDenied}
            sx={{
              alignSelf: "flex-end",
              bgcolor: "#2563eb",
              "&:hover": { bgcolor: "#1d4ed8" },
              color: "#fff",
              px: 2,
              py: 1,
              borderRadius: 2,
              cursor: "pointer",
              textTransform: "none",
              width: "auto",
            }}
          >
            Got It
          </Button>
        </Box>
      </PortalDialog>
    </>
  );
}
